// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2340b83a","488":"ea2de58d","977":"43d98e01"}[chunkId] + ".chunk.js";
};